import { parseAsDateUTC, toISODatewithoutTimezone } from 'app/infrastructure/data/date';
import { SavedReportEvaluationWire } from 'app/area/shared/saved-reports/types';

import { normalizeSequence } from './normalize-sequence';
import { SavedReportDashboardWire } from './types';
import { SavedReportDashboard } from './types-store';

export const mapSavedReportsFromWire = (
  savedReports: SavedReportDashboardWire[],
  evaluationsWire: SavedReportEvaluationWire[]
): SavedReportDashboard[] => {
  return normalizeSequence(savedReports
    ?.map(savedReport => ({
      code: {
        value: savedReport.code?.v,
        description: savedReport.code?.d
      },

      selectedReport: evaluationsWire
        ?.find(evaluation => evaluation.code?.v === savedReport.code?.v)
        ?.report,

      editable: evaluationsWire
        ?.find(evaluation => evaluation.code?.v === savedReport.code?.v)
        ?.editable ?? false,

      sequence: savedReport.sequence,

      disabled: parseAsDateUTC(savedReport.disabled),

      minWidth: savedReport.minWidth,

      height: savedReport.height
    })));
};

export const mergeSavedReportsWithEvaluations = (
  savedReports: SavedReportDashboard[],
  evaluationsWire: SavedReportEvaluationWire[]
): SavedReportDashboard[] => {
  return savedReports
    ?.map(savedReport => ({
      ...savedReport,

      code: {
        value: savedReport.code?.value,
        description: savedReport.code?.description
      },

      selectedReport: evaluationsWire
        ?.find(evaluation => evaluation.code?.v === savedReport.code?.value)
        ?.report,

      editable: evaluationsWire
        ?.find(evaluation => evaluation.code?.v === savedReport.code?.value)
        ?.editable ?? false
    }));
};

export const mapSavedReportsToWire = (savedReports: SavedReportDashboard[]): SavedReportDashboardWire[] => {
  return savedReports
    ?.map(savedReport => ({
      code: {
        v: savedReport.code?.value,
        d: savedReport.code?.description
      },

      sequence: savedReport.sequence,

      disabled: savedReport?.disabled
        ? toISODatewithoutTimezone(savedReport.disabled)()
        : undefined,

      minWidth: savedReport.minWidth,

      height: savedReport.height
    })) ?? [];
};
